import { render, staticRenderFns } from "./ManagerStyle.vue?vue&type=template&id=24a40cf0&scoped=true&"
import script from "./ManagerStyle.vue?vue&type=script&lang=js&"
export * from "./ManagerStyle.vue?vue&type=script&lang=js&"
import style0 from "./ManagerStyle.vue?vue&type=style&index=0&id=24a40cf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a40cf0",
  null
  
)

export default component.exports